import type { ApiMessage } from '../../api/types';
import { areDeepEqual } from '../../util/areDeepEqual';

import { archiveMessageSnapshot } from './store';

export function trackMessageArchiveUpdate(
  previousMessage: ApiMessage | undefined,
  updatedMessage: ApiMessage,
) {
  const contentChanged = previousMessage
    && updatedMessage.content
    && !areDeepEqual(previousMessage.content, updatedMessage.content);

  if (contentChanged || updatedMessage.editHistory?.length || updatedMessage.isDeleted) {
    archiveMessageSnapshot(updatedMessage, {
      editHistory: updatedMessage.editHistory,
      isDeleted: updatedMessage.isDeleted,
    });
  }
}

export function trackDeletedMessageArchive(message: ApiMessage) {
  archiveMessageSnapshot(message, { isDeleted: true });
}
